import { BaseEntity } from 'yt-ng-framework';


export class RadnaKnjizicaView extends BaseEntity {
    constructor() {
        super();
    }
    Osoba: string = null;
    OrgJed: string = null;
    NazivISedistePoslodavca: string = null;
    StazMeseci: number = null;
    StazGodina: number = null;
    StazDana: number = null;
    OdDatuma: Date = null;
    DoDatuma: Date = null;
    PrcAng: number = null;
    NedFondSati: number = null;
    //Staz: string = null;


    Deserialize(input: any) {
        this.ID = input.ID;
        this.Osoba = input.Osoba;
        this.OrgJed = input.OrgJed;
        this.NazivISedistePoslodavca = input.naziv_i_sediste_poslodavca;
        this.StazMeseci = input.staz_meseci;
        this.StazGodina = input.staz_godina;
        this.StazDana = input.staz_dana;
        this.OdDatuma = input.od_datuma;
        this.DoDatuma = input.do_datuma;
        this.PrcAng = input.prc_ang;
        this.NedFondSati = input.ned_fond_sati;
        //this.Staz = input.staz_godina +  ' godina, ' + input.staz_meseci + ' meseca, i ' + input.staz_dana + ' dana';
        return this;
    }

    Serialize(input: RadnaKnjizicaView) {
        return input;
    }
}
